import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import _ from "lodash";
import {
  phd,
  postgradute,
  PostgraduateDeploma,
} from "../../../data/programs";
import PageHero from "./PageHero";

const ProgramCard = ({ program }) => (
  <article className="pg-card flex h-full flex-col overflow-hidden border border-sky-100 bg-white">
    <div className="pg-media">
      <img
        src={program.img}
        alt=""
        className="h-40 w-full object-cover"
      />
    </div>
    <div className="flex flex-1 flex-col p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-[#0863AA]">
        {program.school}
      </p>
      <h3 className="mt-2 flex-1 text-lg font-bold leading-snug text-slate-900">
        {program.program}
      </h3>
      <Link
        to={`/academics/postgraduate/${program.tag}`}
        className="mt-4 inline-flex w-fit bg-[#0863AA] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#0a4f86]"
      >
        Details
      </Link>
    </div>
  </article>
);

const ProgramBrowser = ({ list }) => {
  const schools = useMemo(() => _.uniq(_.map(list, "school")), [list]);
  const [selected, setSelected] = useState("ALL");

  const filtered =
    selected === "ALL" ? list : _.filter(list, ["school", selected]);

  const grouped = useMemo(
    () => _.groupBy(filtered, "school"),
    [filtered]
  );

  return (
    <div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <label
          htmlFor="pg-faculty-filter"
          className="bg-slate-200 px-3 py-2 text-sm font-semibold text-slate-700"
        >
          Filter by faculty
        </label>
        <select
          id="pg-faculty-filter"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="w-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-800 focus:border-[#0863AA] focus:outline-none focus:ring-1 focus:ring-[#0863AA] sm:max-w-md"
        >
          <option value="ALL">All faculties</option>
          {schools.map((school) => (
            <option key={school} value={school}>
              {school}
            </option>
          ))}
        </select>
      </div>

      <div className="mt-10 space-y-12">
        {Object.keys(grouped).map((school) => (
          <section key={school}>
            <div className="mb-5 flex items-end justify-between gap-3 border-b-2 border-[#5eb3d4] pb-3">
              <h2 className="text-xl font-bold text-[#0a3d6b] sm:text-2xl">
                {school}
              </h2>
              <span className="text-sm text-slate-500">
                {grouped[school].length} programme
                {grouped[school].length === 1 ? "" : "s"}
              </span>
            </div>
            <div className="pg-stagger grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
              {grouped[school].map((program) => (
                <ProgramCard key={program.id} program={program} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

const PostgradPrograms = () => {
  return (
    <div>
      <PageHero
        kicker="Our Programs"
        title="Postgraduate pathways at Benadir"
        subtitle="Explore PhD, Masters, and Postgraduate Diploma programmes organised by the Benadir faculties that deliver them."
      />

      <section className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <Tabs defaultIndex={1}>
          <TabList className="mb-8 flex flex-wrap gap-2 border-b-2 border-[#5eb3d4] bg-transparent p-0">
            <Tab
              selectedClassName="!bg-[#0863AA] !text-white"
              className="cursor-pointer list-none bg-[#0863AA]/10 px-5 py-2 text-base font-semibold text-[#0a3d6b] outline-none"
            >
              PhD Programs
            </Tab>
            <Tab
              selectedClassName="!bg-[#0863AA] !text-white"
              className="cursor-pointer list-none bg-[#0863AA]/10 px-5 py-2 text-base font-semibold text-[#0a3d6b] outline-none"
            >
              Masters Programs
            </Tab>
            <Tab
              selectedClassName="!bg-[#0863AA] !text-white"
              className="cursor-pointer list-none bg-[#0863AA]/10 px-5 py-2 text-base font-semibold text-[#0a3d6b] outline-none"
            >
              Diploma Programs
            </Tab>
          </TabList>
          <TabPanel>
            <ProgramBrowser list={phd} />
          </TabPanel>
          <TabPanel>
            <ProgramBrowser list={postgradute} />
          </TabPanel>
          <TabPanel>
            <ProgramBrowser list={PostgraduateDeploma} />
          </TabPanel>
        </Tabs>
      </section>
    </div>
  );
};

export default PostgradPrograms;
